// =============================
// Imports
// =============================

import { createRef, Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import normalizeWheel from 'normalize-wheel';
import { Transition, TransitionGroup } from 'react-transition-group';

import { FixedWrapper, Title, Wrapper, Cover, ScrollArea } from './styles';

// =============================
// Component
// =============================

class CoverSlider extends Component {
  static displayName = 'CoverSliderDesktop';

  static propTypes = {
    /** Props used by styled component to override styles */
    className: PropTypes.string,
    /** Array of Cover item */
    covers: PropTypes.arrayOf(
      PropTypes.shape({
        /** Id of the player context */
        contextId: PropTypes.string,
        /** Name of the player context */
        contextName: PropTypes.string,
        description: PropTypes.string,
        key: PropTypes.string,
        linkProps: PropTypes.shape({
          route: PropTypes.string,
          nextAs: PropTypes.string,
        }),
        placeholderType: PropTypes.string,
        preText: PropTypes.string,
        src: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        title: PropTypes.string,
        type: PropTypes.string,
        vynil: PropTypes.bool,
      }),
    ),
    /** next-routes Link component. */
    LinkComponent: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    /** Title of slider */
    title: PropTypes.string.isRequired,
  };

  static defaultProps = {
    className: '',
    covers: [],
    LinkComponent: null,
  };

  constructor(props) {
    super(props);

    this.delta = 0;
    this.scrollAreaRef = createRef();
  }

  componentDidMount() {
    // Start listening to mousewheel when component mounts
    this.scrollAreaRef.current.addEventListener('wheel', this.handleMouseWheel);
  }

  componentWillUnmount() {
    // Stop listening to mousewheel when component mounts
    this.scrollAreaRef.current.removeEventListener('wheel', this.handleMouseWheel);
  }

  handleMouseWheel = (e) => {
    if (e.type !== 'wheel') {
      return;
    }
    // this.scrollAreaRef.current.scrollLeft -= normalizeWheel(e).pixelY;
    // return;
    this.delta += normalizeWheel(e).pixelY;
    requestAnimationFrame(() => {
      if (this.delta === 0) return;
      this.scrollAreaRef.current.scrollLeft += this.delta;
      this.delta = 0;
    });
    e.preventDefault();
  };

  render() {
    const { className, covers, LinkComponent, title } = this.props;

    return (
      <Fragment>
        <Title>{title}</Title>
        <FixedWrapper>
          <ScrollArea ref={this.scrollAreaRef}>
            <Wrapper className={className}>
              <TransitionGroup appear component={null}>
                {covers.map((cover, i) => (
                  <Transition key={cover.key} timeout={800}>
                    {state => (
                      <Cover
                        contextId={cover.contextId}
                        contextName={cover.contextName}
                        description={cover.description}
                        index={i}
                        key={cover.key}
                        lazyload={i >= 5}
                        LinkComponent={LinkComponent}
                        linkProps={cover.linkProps}
                        placeholderType={cover.placeholderType}
                        preText={cover.preText}
                        src={cover.src}
                        state={state}
                        title={cover.title}
                        alt={cover.title}
                        type={cover.type}
                        vynil={cover.vynil || false}
                      />
                    )}
                  </Transition>
                ))}
              </TransitionGroup>
            </Wrapper>
          </ScrollArea>
        </FixedWrapper>
      </Fragment>
    );
  }
}

export default CoverSlider;
